import styles from "./BoostTip.module.css";

export const BoostTip: React.FC = () => {
	return (
		<div className={styles.tipContainer}>
			<h3 className={styles.title}>Буст наград:</h3>
			<div className={styles.content}>
				<p className={styles.description}>
					Чем больше работников нанято, тем выше шанс на редкие награды.
				</p>

				<div className={styles.boostLevels}>
					<div className={styles.boostLevel}>
						<span className={styles.level}>1 работник:</span>
						<span className={styles.multiplier}>x1.0</span>
					</div>
					<div className={styles.boostLevel}>
						<span className={styles.level}>2 работника:</span>
						<span className={styles.multiplier}>x1.5</span>
					</div>
					<div className={styles.boostLevel}>
						<span className={styles.level}>3 работника:</span>
						<span className={styles.multiplier}>x2.0</span>
					</div>
				</div>
			</div>
		</div>
	);
};
